/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logoMark from "assets/img/brand/logo-mark.svg";

import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[32px] mt-[50px] flex items-center gap-2`}>
        <div
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
          style={{ background: "linear-gradient(135deg, #9b5de5, #D4AF37)" }}
        >
          <img
            src={logoMark}
            alt="Findule"
            className="h-5 w-5"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>
        <div className="font-poppins text-xl font-bold uppercase text-navy-700 dark:text-white">
          Findule <span className="font-medium">Admin</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
